import { Component } from '@angular/core';

@Component({
  selector: 'app-organizer-interest',
  imports: [],
  templateUrl: './organizer-interest.html',
  styleUrl: './organizer-interest.css',
})
export class OrganizerInterest {}
